<script lang="ts">
  import Skeleton from "../skeletons/Skeleton.svelte";

  const skeletonDimensionsByID = new Map<string, { width: string; height: string }>([
    ["supplier_name", { width: "60px", height: "10px" }],
    ["type", { width: "30px", height: "10px" }],
    ["reference", { width: "60px", height: "10px" }],
    ["notes", { width: "36px", height: "10px" }],
    ["amount", { width: "36px", height: "10px" }],
    ["delivery_date", { width: "96px", height: "10px" }],
    ["date", { width: "12px", height: "12px" }],
    ["filter", { width: "12px", height: "12px" }],
    ["status", { width: "30px", height: "10px" }],
    ["total_spend", { width: "60px", height: "10px" }],
  ]);

  const DEFAULT_DIMENSIONS = { width: "12px", height: "12px" };

  export let colID: string;
  export let start: boolean = false;
  export let end: boolean = false;
</script>

<div
  role="columnheader"
  class="col"
  class:colstart={colID === "date" || start}
  class:colend={colID === "filter" || end}
  class:supplier={colID === "supplier_name"}
>
  <Skeleton
    color="light"
    --skeleton-height={skeletonDimensionsByID.get(colID)?.height ?? DEFAULT_DIMENSIONS.height}
    --skeleton-width={skeletonDimensionsByID.get(colID)?.width ?? DEFAULT_DIMENSIONS.height}
  />
</div>

<style>
  .col {
    display: flex;
    border-color: var(--rk-divider-0);
    background-color: var(--rekki-neutral-00);
    border-color: var(--rk-divider-0);
    min-height: 32px;
    align-items: center;
    padding-left: 12px;
    padding-right: 12px;
  }

  .colstart {
    border-top-left-radius: var(--rk-rounding-s);
    border-bottom-left-radius: var(--rk-rounding-s);
    justify-content: center;
    padding-left: 0px;
    padding-right: 0px;
  }

  .colend {
    border-top-right-radius: var(--rk-rounding-s);
    border-bottom-right-radius: var(--rk-rounding-s);
    justify-content: end;
  }

  .supplier {
    padding-left: 24px;
  }
</style>
